import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {
    
    // Slider posts
    const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;
                
    if (postsSlideshow) {
        let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, EffectFade, Navigation ]);

        let postsConfig = {
            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop : true,
            slidesPerView: 'auto',

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true, 
            },

            navigation: {
                nextEl: `.posts .swiper-button-next`,
                prevEl: `.posts .swiper-button-prev`,
            },
        }

        go();
        window.addEventListener('resize', go);

        function go(){
            if(window.innerWidth > 960){
                if(postsSlides > 3){
                    let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
                }
            }
            else if(window.innerWidth > 640){
                if(postsSlides > 2){
                    let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
                }
            }
            else {
                if(postsSlides > 1){
                    let swiperPosts = new Swiper('.posts .swiper-container', postsConfig);
                }
            }
        }

    }


}
